<template lang="pug">
  b-card.w-100(no-body)
    div(slot="header") {{$t('management_page.connection_maintenance_policy')}}
      span.ml-2(@click="showDialog('remotePolicy')") 
        icon(name="question-circle")
    b-list-group
      b-list-group-item
        b-row
          b-col.d-flex.align-items-center(cols="12" md="12" lg="2") {{$t('management_page.forced_logout_manager')}}
          b-col.d-flex.align-items-center.contents(cols="12" md="12" lg="10")
            .switch.mr-2
              b-form-input.d-inline-block(v-model="form.manager_session_timeout" size="sm" type="number" min="0" max="600" @blur="inputMax(600)" style="width: 50px;")
              span.ml-1 {{$t('minute')}}
            .msg
              span {{$t('management_page.web_app_manager_forced_logout')}}
      
      b-list-group-item
        b-row
          b-col.d-flex.align-items-center(cols="12" md="12" lg="2") {{$t('management_page.idle_auto_logout_manager')}}
          b-col.d-flex.align-items-center.contents(cols="12" md="12" lg="10")
            .switch.mr-2
              b-form-input.d-inline-block(v-model="form.manager_idle_timeout" size="sm" type="number" min="0" max="600" @blur="inputMax(600)" style="width: 50px;")
              span.ml-1 {{$t('minute')}}
            .msg
              span {{$t('management_page.web_app_manager_idle_logout')}}
      
      b-list-group-item
        b-row
          b-col.d-flex.align-items-center(cols="12" md="12" lg="2") {{$t('management_page.forced_termination_viewer')}}
          b-col.d-flex.align-items-center.contents(cols="12" md="12" lg="10")
            .switch.mr-2
              b-form-input.d-inline-block(v-model="form.session_timeout" size="sm" type="number" min="0" max="600" @blur="inputMax(600)" style="width: 50px;")
              span.ml-1 {{$t('minute')}}
            .msg
              span {{$t('management_page.remote_connection_forced_termination')}}
      
      b-list-group-item
        b-row
          b-col.d-flex.align-items-center(cols="12" md="12" lg="2") {{$t('management_page.idle_auto_termination_viewer')}}
          b-col.d-flex.align-items-center.contents(cols="12" md="12" lg="10")
            .switch.mr-2
              b-form-input.d-inline-block(v-model="form.idle_timeout" size="sm" type="number" min="0" max="600" @blur="inputMax(600)" style="width: 50px;")
              span.ml-1 {{$t('minute')}}
            .msg
              span {{$t('management_page.remote_connection_idle_termination')}}
    
    dialog-remote-policy(:show.sync="show.remotePolicy")
</template>

<script>
import Switches from "vue-switches"
import DialogRemotePolicy from "./dialog/dialogRemotePolicy.vue"

export default {
  props: {
    form: {
      type: Object,
      default: () => {
        return {
          time1: 0,
          time2: 0,
          time3: 0,
          time4: 0,
        }
      },
    },
  },
  components: {
    Switches,
    DialogRemotePolicy,
  },
  data() {
    return {
      show: {
        remotePolicy: false,
      },
    }
  },
  methods: {
    showDialog(type) {
      this.show[type] = true
    },
    inputMax(max) {
      if (this.form.time1 > max) {
        this.form.time1 = max
      }
    },
  },
}
</script>

<style lang="scss" scoped></style>
